import { SiteHeader, SiteFooter } from "@/components/demo/DemoShell";

const INLINE_IMG =
  "https://images.unsplash.com/photo-1575330734740-21b22ac7bf5e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxtaW5pbWFsJTIwYWJzdHJhY3R8ZW58MHx8fHdoaXRlfDE3ODc2MTU2MDV8MA&ixlib=rb-4.1.0&q=85&w=1400";

export default function DemoArticle() {
  return (
    <div data-testid="demo-article" className="min-h-screen bg-white text-slate-900">
      <SiteHeader />

      <article data-testid="article-body" className="mx-auto max-w-2xl px-5 pt-16 pb-4 sm:px-8 sm:pt-24">
        <span
          data-testid="article-category"
          className="text-xs font-semibold uppercase tracking-widest text-indigo-600"
        >
          Sample Article
        </span>
        <h1 data-testid="article-title" className="mt-4 text-4xl font-bold leading-[1.15] tracking-tight sm:text-[42px]">
          Neque porro quisquam est qui dolorem ipsum
        </h1>

        <div data-testid="article-byline" className="mt-6 flex items-center gap-3 border-b border-slate-200 pb-6">
          <div className="h-10 w-10 rounded-full bg-slate-200" />
          <div className="text-sm">
            <p className="font-semibold text-slate-900">By Sample Author</p>
            <p className="text-slate-500">July 2025 · 5 min read</p>
          </div>
        </div>

        <div className="prose prose-slate mt-8 space-y-6 text-[17px] leading-8 text-slate-700">
          <p data-testid="article-p1">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat.
          </p>
          <p data-testid="article-p2">
            Duis aute irure dolor in reprehenderit in voluptate velit esse
            cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
            cupidatat non proident, sunt in culpa qui officia deserunt mollit
            anim id est laborum.
          </p>

          <figure data-testid="article-figure" className="my-10">
            <img
              data-testid="article-image"
              src={INLINE_IMG}
              alt="Sample inline abstract"
              className="w-full rounded-xl object-cover ring-1 ring-slate-200"
            />
            <figcaption className="mt-3 text-center text-sm text-slate-400">
              Sample caption — a neutral inline image.
            </figcaption>
          </figure>

          <p data-testid="article-p3">
            Sed ut perspiciatis unde omnis iste natus error sit voluptatem
            accusantium doloremque laudantium, totam rem aperiam, eaque ipsa
            quae ab illo inventore veritatis et quasi architecto beatae vitae.
          </p>

          <blockquote
            data-testid="article-blockquote"
            className="border-l-4 border-indigo-600 bg-slate-50 py-4 pl-6 pr-4 text-xl font-medium italic text-slate-800"
          >
            “Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit
            aut fugit, sed quia consequuntur magni dolores.”
          </blockquote>

          <p data-testid="article-p4">
            At vero eos et accusamus et iusto odio dignissimos ducimus qui
            blanditiis praesentium voluptatum deleniti atque corrupti quos
            dolores et quas molestias excepturi sint occaecati cupiditate.
          </p>
        </div>
      </article>

      <SiteFooter />
    </div>
  );
}
